<template>
  <SingleSelectComponent
    v-if="projects && selectedProject"
    v-model:model-value="selectedProject"
    :options-single="
      projects.map((project) => ({ value: project.id ?? '', text: project.name ?? '' }))
    "
    select-text="Select project"
  />
</template>

<script setup lang="ts">
import { Project, ProjectClient } from '@/server/MakeSenseApp-backend'
import { onMounted, ref, watch } from 'vue'
import { useProjectStore } from '@/stores/ProjectStore'
import SingleSelectComponent from '../general/select/SingleSelectComponent.vue'
import { requiredInject } from '@/utilities/requiredInject'

let projects = ref<Array<Project>>([])
let selectedProject = ref<{ value: string; text: string } | null>(null)

let store = useProjectStore()
const projectClient = requiredInject<ProjectClient>('ProjectClient')

watch(selectedProject, (newValue) => {
  if (newValue !== null) {
    store.setProject(projects.value.find((x) => x.id === newValue!.value))
    sessionStorage.setItem('selectedProject', JSON.stringify(newValue)) // Save in session storage
  }
})

onMounted(() => {
  watch(
    () => store.refreshCounter,
    () => {
      projectClient
        .getProjects()
        .then((data) => {
          projects.value = data

          const savedProject = sessionStorage.getItem('selectedProject')
          const parsedProject = savedProject ? JSON.parse(savedProject) : null

          if (parsedProject && data.some((p) => p.id === parsedProject.value)) {
            selectedProject.value = parsedProject // Restore previous selection if valid
          } else if (data.length > 0 && data[0].id) {
            selectedProject.value = {
              value: data[0].id,
              text: data[0].name!
            }
          } else {
            selectedProject.value = null
            store.setNoProjects()
          }
        })
        .catch((reason: any) => {
          if (reason.status === 403) {
            store.setNoProjects()
          } else {
            throw reason
          }
        })
    },
    { immediate: true }
  )
})
</script>
